import * as styles from './styles';

const DefaultContent = () => {
  return (
    <div>
      <div css={styles.videoGradiant} />
      <p css={styles.title}>
        의사를 만나는
        <br />
        가장 빠른 방법
        <br />
        굿닥 비대면 진료
      </p>
    </div>
  );
};

export default DefaultContent;
